module.exports = __webpack_public_path__ + "img/not-found.c436a070.svg";